import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import useStore from 'zustand-store';
import NavGroup from './NavGroup';
import { generateMenuItems } from 'utils/menu-items';
import { NavItemType } from 'types/menu';

const Navigation = () => {
  const { role } = useStore(state => state.loggedUser);
  const { deliverySectionStatus, analyticsSectionStatus } = useStore(state => state.professionalAccount);
  const [selectedItems, setSelectedItems] = useState<string | undefined>('');
  const [selectedLevel, setSelectedLevel] = useState<number>(0);

  const menuItem = generateMenuItems(role, deliverySectionStatus, analyticsSectionStatus);

  const lastItem = null;
  let lastItemIndex = menuItem.items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string;

  if (lastItem && lastItem < menuItem.items.length) {
    lastItemId = menuItem.items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = menuItem.items.slice(lastItem - 1, menuItem.items.length).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon
    }));
  }

  const navGroups = menuItem.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case 'group':
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });
  return (
    <Box
      sx={{
        pt: 2,
        '& > ul:first-of-type': { mt: 0 },
        display: 'block'
      }}
    >
      {navGroups}
    </Box>
  );
};

export default Navigation;
